goog.provide('el8.util.print');


el8.util.print = {
    /**
     * Calling pageSetup will trigger autoprint unless
     * window.disableAutoPrint is set to true.
     */
    pageSetup: function() {
        $('.pageBreak:visible:last').removeClass('pageBreak');

        if (window.disableAutoPrint !== true) {
            if ( $('img').length > 0) {
                window.setupPrintOnImageLoadedHandlers();
            } else {
                window.print();
            }
        }
    }

};

